import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import MaterialTable from "@material-table/core";
import Snackbars from '../../pages/Snackbars';
import { useTranslation } from "react-i18next";
import axios from 'axios';
import Loader from '../../pages/Loader';
import validator from 'validator';
import 'jspdf-autotable';
import { checkauhtoken } from '../../../api/PrePageLoad';
import { Tooltip } from "@material-ui/core";

export const Customer_List = () => {
    const { t } = useTranslation();
    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error_msg, setErrorMsg] = useState("");
    const [success_msg, setSuccessMsg] = useState("");


    const [UserData, setUserData] = useState([]);
    const [CountryData, setCountryData] = useState([]);
    const [FilterData, setFilterData] = useState([]);


    const [FirstName, setFirstName] = useState("");
    const [FirstNameError, setFirstNameError] = useState("");
    const [LastName, setLastName] = useState("");
    const [LastNameError, setLastNameError] = useState("");
    const [Email, setEmail] = useState("");
    const [EmailError, setEmailError] = useState("");
    const [CountryCode, setCountryCode] = useState("1");
    const [Phone, setPhone] = useState("");
    const [PhoneError, setPhoneError] = useState("");
    const [Modal1, setModal1] = useState(false);
    const validateFirstName = (value) => {
        setFirstName(value);
        if (validator.isEmpty(value)) {
            setFirstNameError("First Name is required.");
            return false;
        } else {
            setFirstNameError("");
            return true;
        }
    }
    const validateLastName = (value) => {
        setLastName(value);
        if (validator.isEmpty(value)) {
            setLastNameError("Last Name is required.");
            return false;
        } else {
            setLastNameError("");
            return true;
        }
    }
    const validateEmail = (value) => {
        setEmail(value);
        if (validator.isEmpty(value)) {
            setEmailError("Email ID is required.");
            return false;
        } else if (!validator.isEmail(value)) {
            setEmailError(t("Please Enter Correct Email Format."));
            return false;
        } else {
            setEmailError("");
            return true;
        }
    }
    const validateCountryCode = (value) => {
        setCountryCode(value);
    }
    const validatePhone = (value) => {
        setPhone(value);
        if (validator.isEmpty(value)) {
            setPhoneError("Phone number is required.");
            return false;
        } if (!validator.isNumeric(value)) {
            setPhoneError("Phone number is invalid.");
            return false;
        } else {
            setPhoneError("");
            return true;
        }
    }
    const handlesubmit = () => {
        if (!validateFirstName(FirstName)) {
            return false;
        } else if (!validateLastName(LastName)) {
            return false;
        } else if (!validateEmail(Email)) {
            return false;
        } else if (!validatePhone(Phone)) {
            return false;
        } else {
            setModal1(false);
            setLoader(true);

            let jsonpar = JSON.stringify({
                'first_name': FirstName,
                'last_name': LastName,
                'email_id': Email,
                'country_code': CountryCode,
                'phone_number': Phone,
                'usergroup': allusergroup.length > 0 ? allusergroup[0].group_id : 1,
            });
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            axios.post(process.env.REACT_APP_API_URL + 'account/addCustomer', jsonpar, {
                headers: headers
            })
                .then(function (res) {
                    res = res.data;
                    setLoader(false);

                    if (res.code === "200") {
                        handleLoad();

                        setFirstName("");
                        setLastName("");
                        setEmail("");
                        setCountryCode("1");
                        setPhone("");

                        setSuccess(true);
                        setSuccessMsg(res.message);
                        setTimeout(() => {
                            setSuccess(false);
                        }, 6000);
                    } else {
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    }

                })
                .catch(function (error) {
                    setLoader(false);

                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });
        }
    }

    const [AccountID3, setAccountID3] = useState("");
    const [Modal3, setModal3] = useState(false);
    const openModal3 = (accountIDVal) => {
        setAccountID3(accountIDVal);
        setModal3(true);
    }
    const handlesubmit3 = () => {
        setModal3(false);
        setLoader(true);

        let jsonpar = JSON.stringify({
            'user_id': AccountID3
        });
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.post(process.env.REACT_APP_API_URL + 'account/deleteCustomer', jsonpar, {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                setLoader(false);

                if (res.code === "200") {
                    handleLoad();

                    setAccountID3("");

                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setLoader(false);

                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const [AccountID5, setAccountID5] = useState("");
    const [Modal5, setModal5] = useState(false);
    const openModal5 = (accountIDVal) => {
        setAccountID5(accountIDVal);
        setModal5(true);
    }
    const handlesubmit5 = () => {
        setModal5(false);
        setLoader(true);

        let jsonpar = JSON.stringify({
            'user_id': AccountID5
        });
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.post(process.env.REACT_APP_API_URL + 'account/resendCustomerEmail', jsonpar, {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                setLoader(false);
                if (res.code === "200") {
                    setAccountID5("");

                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setLoader(false);

                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const [Modal6, setModal6] = useState(false);
    const handlesubmit6 = () => {
        setModal6(false);
        setLoader(true);

        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'account/addedAllShareHolders', {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                setLoader(false);
                if (res.code === "200") {
                    window.location.reload();

                    setSuccess(true);
                    setSuccessMsg(res.message);
                    setTimeout(() => {
                        setSuccess(false);
                    }, 6000);
                } else {
                    setError(true);
                    setErrorMsg(res.message);
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                }

            })
            .catch(function (error) {
                setLoader(false);

                setError(true);
                setErrorMsg(t('ERROR_MSG.SOMETHING'));
                setTimeout(() => {
                    setError(false);
                }, 6000);
            });
    }

    const [UserID4, setUserID4] = useState("");
    const [CustomerName, setCustomerName] = useState("");
    const [CustomerNameError, setCustomerNameError] = useState("");
    const [CustomerName2, setCustomerName2] = useState("");
    const [CustomerName2Error, setCustomerName2Error] = useState("");
    const [CustomerEmail, setCustomerEmail] = useState("");
    const [CustomerEmailError, setCustomerEmailError] = useState("");
    const [CustomerCountryCode, setCustomerCountryCode] = useState("1");
    const [CustomerPhone, setCustomerPhone] = useState("");
    const [CustomerPhoneError, setCustomerPhoneError] = useState("");
    const [CustomerBroker, setCustomerBroker] = useState("");
    const [Modal4, setModal4] = useState(false);

    const [allusergroup, setallusergroup] = useState([]);
    const [EditGroup, setEditGroup] = useState("");

    const openModal4 = (element, allbrokers) => {
        setUserID4(element.user_id_pk);
        setCustomerName(element.first_name);
        setCustomerName2(element.last_name);
        setCustomerEmail(element.email_id);
        setCustomerCountryCode(element.country_code);
        setCustomerPhone(element.phone_number);
        setCustomerBroker(element.broker_id);
        setEditGroup(element.user_group_id);
        setModal4(true);
    }
    const validateCustomerName = (value) => {
        setCustomerName(value);
        if (validator.isEmpty(value)) {
            setCustomerNameError("First Name is required.");
            return false;
        } else {
            setCustomerNameError("");
            return true;
        }
    }
    const validateCustomerName2 = (value) => {
        setCustomerName2(value);
        if (validator.isEmpty(value)) {
            setCustomerName2Error("Last Name is required.");
            return false;
        } else {
            setCustomerName2Error("");
            return true;
        }
    }
    const validateCustomerEmail = (value) => {
        setCustomerEmail(value);
        if (validator.isEmpty(value)) {
            setCustomerEmailError("Email ID is required.");
            return false;
        } else if (!validator.isEmail(value)) {
            setCustomerEmailError(t("Please Enter Correct Email Format."));
            return false;
        } else {
            setCustomerEmailError("");
            return true;
        }
    }
    const validateCustomerCountryCode = (value) => {
        setCustomerCountryCode(value);
    }
    const validateCustomerPhone = (value) => {
        setCustomerPhone(value);
        if (validator.isEmpty(value)) {
            setCustomerPhoneError("Phone number is required.");
            return false;
        } if (!validator.isNumeric(value)) {
            setCustomerPhoneError("Phone number is invalid.");
            return false;
        } else {
            setCustomerPhoneError("");
            return true;
        }
    }
    const handlesubmit4 = () => {
        if (!validateCustomerName(CustomerName)) {
            return false;
        } else if (!validateCustomerName2(CustomerName2)) {
            return false;
        } else {
            setModal4(false);
            setLoader(true);

            let jsonpar = JSON.stringify({
                'user_id': UserID4,
                'customer_name': CustomerName,
                'customer_name_2': CustomerName2,
                'customer_broker': CustomerBroker,
                'usergroup': EditGroup,
            });
            const headers = {
                'Content-Type': 'application/json',
                'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
                'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
            }
            axios.post(process.env.REACT_APP_API_URL + 'account/updateCustomer', jsonpar, {
                headers: headers
            })
                .then(function (res) {
                    res = res.data;
                    setLoader(false);

                    if (res.code === "200") {
                        handleLoad();

                        setUserID4("");
                        setCustomerName("");
                        setCustomerName2("");
                        setCustomerEmail("");
                        setCustomerCountryCode("1");
                        setCustomerPhone("");
                        setCustomerBroker("");
                        setEditGroup("");
                        setSuccess(true);
                        setSuccessMsg(res.message);
                        setTimeout(() => {
                            setSuccess(false);
                        }, 6000);
                    } else {
                        setError(true);
                        setErrorMsg(res.message);
                        setTimeout(() => {
                            setError(false);
                        }, 6000);
                    }

                })
                .catch(function (error) {
                    setLoader(false);

                    setError(true);
                    setErrorMsg(t('ERROR_MSG.SOMETHING'));
                    setTimeout(() => {
                        setError(false);
                    }, 6000);
                });
        }
    }

    const handleLoad = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'account/getAllCustomer', {
            headers: headers
        })
            .then(function (res) {
                res = res.data;
                if (res.code === "200") {
                    setallusergroup(res.allusergrp);
                    let CustomerEmailTempArr = [];
                    let CustomerDataTempArr = [];
                    let TempArr = [];
                    res.data.forEach(element => {
                        if (!CustomerEmailTempArr.includes(element.email_id)) {
                            let CustomerTempArr = {
                                CustomerNameNEmail: element.first_name + " " + element.last_name + " (" + element.email_id + ")",
                                CustomerEmail: element.email_id,
                            }
                            CustomerDataTempArr.push(CustomerTempArr);
                            CustomerEmailTempArr.push(element.email_id);
                        }

                        let ActionBTN = "-" 
                        if (element.user_kyc_kyc_api_status === "Pending") {
                            ActionBTN = <div style={{ minWidth: "175px" }}>
                                <Tooltip title="Edit"><button className="btn btn-primary shadow btn-xs edit-shape" onClick={() => openModal4(element, res.allbrokers)}><i className="fa fa-pencil" aria-hidden="true"></i></button></Tooltip>
                                <Tooltip title="Resend Email"><button className="btn btn-success shadow btn-xs edit-shape" onClick={() => openModal5(element.user_id_pk)}><i className="fa fa-refresh" aria-hidden="true"></i></button></Tooltip>
                                <Tooltip title="Delete"><button className="btn btn-danger shadow btn-xs edit-shape" onClick={() => openModal3(element.user_id_pk)}><i className="fa fa-trash-o" aria-hidden="true"></i></button></Tooltip>
                            </div>;
                        }
                        
                        let StatusBTN = "-";
                        switch (element.user_kyc_kyc_api_status) {
                            case "Approved":
                                StatusBTN = <div><button className="btn btn-outline-success btn-rounded">Approved</button></div>
                                break;

                            case "Pending":
                                StatusBTN = <div><button className="btn btn-outline-warning btn-rounded">Pending</button></div>
                                break;

                            default:
                                StatusBTN = <div><button className="btn btn-outline-danger btn-rounded">Rejected</button></div>
                                break;
                        }


                        let temp = {
                            No: element.user_id_pk,
                            CustomerName: element.first_name + " " + element.last_name,
                            EmailID: element.email_id,
                            PhoneNumber: "+"+ element.country_code +" "+element.phone_number,
                            Status: StatusBTN,
                            Action: ActionBTN,
                            created_datetime: element.created_datetime,
                            CusName: element.first_name + " " + element.last_name,
                            StatusText: element.user_kyc_kyc_api_status
                        }
                        TempArr.push(temp);
                    });
                    setFilterData(TempArr);
                }
            })
            .catch(function (error) {})
            .finally(function () {
                setLoader(false);
            });
    }

    const handleLoadGetAllCountry = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'account/getAllCountry', {
            headers: headers
        })
        .then(function (res) {
            res = res.data;
            if (res.code === "200") {
                setCountryData(res.data);
            }
        })
        .catch(function (error) {})
        .finally(function () {
            handleLoad();
        });
    }

    const handleLoadGetUserDetails = async () => {
        const headers = {
            'Content-Type': 'application/json',
            'useraccesstoken': process.env.REACT_APP_USER_ACCESS_TOKEN,
            'userauthtoken': 'Bearer ' + window.sessionStorage.getItem("user_jwt"),
        }
        axios.get(process.env.REACT_APP_API_URL + 'getUserDetails', {
            headers: headers
        })
        .then(function (res) {
            res = res.data;
            if (res.code === "200") {
                setUserData(res.data);
            }
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            handleLoadGetAllCountry();
        });
    }

    useEffect(() => {
        checkauhtoken();
        setLoader(true);
        handleLoadGetUserDetails();
    }, []);


    return (
        <div>
            <div className="card bg-0 bg-none">
                <div className="card-header page-title-space mobile-card-header">
                    {UserData && UserData.is_added_all_share_holders === "Yes" ?
                    <h2 className="text-black font-w500 mb-0">Share Holders</h2>
                    :
                    <h2 className="text-green font-w500 mb-0">Add contact information for shareholders owning 25% or more of the company's shares.</h2>
                    }
                    {UserData && UserData.is_added_all_share_holders === "No" && (
                    <div className="mobileFullWidth">
                        <Link to="#" className="btn btn-primary btn-rounded" onClick={() => setModal1(true)}>
                            Add
                        </Link>
                    </div>
                    )}
                </div>
            </div>

            {error ? <Snackbars open_close={error} type="error" message={error_msg} /> : ""}
            {success ? <Snackbars open_close={success} type="success" message={success_msg} /> : ""}

            <Modal className="modal fade" show={Modal1} size="lg">
                <div className="modal-dialog-centered " >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Add</h3>
                            <button type="button" className="close" onClick={() => setModal1(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="mb-2 ">First Name</label>
                                        <input type="text" className="form-control" placeholder="Enter First Name" value={FirstName} onChange={(e) => validateFirstName(e.target.value)} />
                                        {FirstNameError !== "" ? <label className='text-red'>{FirstNameError}</label> : ""}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="mb-2 ">Last Name</label>
                                        <input type="text" className="form-control" placeholder="Enter Last Name" value={LastName} onChange={(e) => validateLastName(e.target.value)} />
                                        {LastNameError !== "" ? <label className='text-red'>{LastNameError}</label> : ""}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="mb-2 ">Email ID</label>
                                        <input type="email" className="form-control" placeholder="Enter Email ID" value={Email} onChange={(e) => validateEmail(e.target.value)} />
                                        {EmailError !== "" ? <label className='text-red'>{EmailError}</label> : ""}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                </div>
                                <div className="col-md-12">
                                    <div className='form-group mb-2 fullWidth'>
                                        <label className='mb-1 fullWidth'>Phone number </label>
                                        <div className="form-group position-relative countrybox1">
                                            <select className="form-control webkit-none" value={CountryCode} onChange={(e) => validateCountryCode(e.target.value)}>
                                                {CountryData && CountryData.map((row) => (
                                                    <option value={row.phonecode} key={row.country_id_pk}>{"+" + row.phonecode + " (" + row.name + ")"}</option>
                                                ))}
                                            </select>
                                            <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                        </div>
                                        <div className='country-text-box1'>
                                            <input type="number" className="form-control" placeholder='Enter Phone number' value={Phone} onChange={(e) => validatePhone(e.target.value)} />
                                            {PhoneError !== "" ? <label className='text-red'>{PhoneError}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light btn-rounded light" onClick={() => setModal1(false)}>Close</button>
                            <button type="button" className="btn btn-primary btn-rounded" onClick={handlesubmit}>Add</button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" show={Modal3}>
                <div className="modal-dialog-centered " >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Delete</h3>
                            <button type="button" className="close" onClick={() => setModal3(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-xs-12">
                                <div className="form-group">
                                    <p className="font-18">Are you sure you want to <strong className="text-danger">Delete</strong> this Share Holder?</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light btn-rounded light" onClick={() => setModal3(false)}>Cancel</button>
                            <button type="button" className="btn btn-primary btn-rounded" onClick={handlesubmit3}>Yes Delete</button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" show={Modal5}>
                <div className="modal-dialog-centered " >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Resend Email</h3>
                            <button type="button" className="close" onClick={() => setModal5(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-xs-12">
                                <div className="form-group">
                                    <p className="font-18">Are you sure you want to <strong className="text-success">Resend</strong> email this Share Holder?</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light btn-rounded light" onClick={() => setModal5(false)}>Cancel</button>
                            <button type="button" className="btn btn-primary btn-rounded" onClick={handlesubmit5}>Yes</button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" show={Modal6}>
                <div className="modal-dialog-centered " >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Confirmation</h3>
                            <button type="button" className="close" onClick={() => setModal6(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="col-xs-12">
                                <div className="form-group">
                                    <p className="font-18">Are you sure you added all shareholders (25%+ ownership)?</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light btn-rounded light" onClick={() => setModal6(false)}>Cancel</button>
                            <button type="button" className="btn btn-primary btn-rounded" onClick={handlesubmit6}>Confirm</button>
                        </div>
                    </div>
                </div>
            </Modal>

            <Modal className="modal fade" show={Modal4} size="lg">
                <div className="modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3 className="modal-title">Edit</h3>
                            <button type="button" className="close" onClick={() => setModal4(false)}><span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="mb-2 ">First Name</label>
                                        <input type="text" className="form-control" placeholder="Enter Full Name" value={CustomerName} onChange={(e) => validateCustomerName(e.target.value)} />
                                        {CustomerNameError !== "" ? <label className='text-red'>{CustomerNameError}</label> : ""}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="mb-2 ">Last Name</label>
                                        <input type="text" className="form-control" placeholder="Enter Last Name" value={CustomerName2} onChange={(e) => validateCustomerName2(e.target.value)} />
                                        {CustomerName2Error !== "" ? <label className='text-red'>{CustomerName2Error}</label> : ""}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="mb-2 ">Email</label>
                                        <input type="email" className="form-control" placeholder="Enter Email ID" value={CustomerEmail} onChange={(e) => validateCustomerEmail(e.target.value)} readOnly />
                                        {CustomerEmailError !== "" ? <label className='text-red'>{CustomerEmailError}</label> : ""}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                </div>
                                <div className="col-md-12">
                                    <div className='form-group mb-2 fullWidth'>
                                        <label className='mb-1 fullWidth'>Phone number </label>
                                        <div className="form-group position-relative countrybox1">
                                            <select className="form-control webkit-none" value={CustomerCountryCode} onChange={(e) => validateCustomerCountryCode(e.target.value)} disabled>
                                                {CountryData && CountryData.map((row) => (
                                                    <option value={row.phonecode} key={row.country_id_pk}>{"+" + row.phonecode + " (" + row.name + ")"}</option>
                                                ))}
                                            </select>
                                            <i className="fa fa-caret-down down-arrow" aria-hidden="true"></i>
                                        </div>
                                        <div className='country-text-box1'>
                                            <input type="number" className="form-control" placeholder="Enter Phone Number" value={CustomerPhone} onChange={(e) => validateCustomerPhone(e.target.value)} readOnly />
                                            {CustomerPhoneError !== "" ? <label className='text-red'>{CustomerPhoneError}</label> : ""}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light btn-rounded light" onClick={() => setModal4(false)}>Close</button>
                            <button type="button" className="btn btn-primary btn-rounded" onClick={handlesubmit4}>Update</button>
                        </div>
                    </div>
                </div>
            </Modal>

            {loader === true ?
                <div>
                    <Loader open_close={loader} />
                </div>
                :
                <>
                <div className="card">
                    <div className="card-body table-action-center">
                        <div className="position-relative">
                            <div className="table-responsive">
                                {FilterData.length > 0 ?
                                    <MaterialTable
                                        title="List Overview"
                                        columns={[
                                            { title: 'Name', field: 'CustomerName' },
                                            { title: 'Email', field: 'EmailID' },
                                            { title: 'Phone Number', field: 'PhoneNumber' },
                                            { title: 'KYC Status', field: 'Status', align: 'center' },
                                            { title: 'Action', field: 'Action', align: 'center' },
                                        ]}
                                        data={FilterData}
                                        options={{
                                            exportMenu: [], 
                                            paging: false, 
                                            pageSize: 25, 
                                            pageSizeOptions: [25, 50, 100], 
                                            emptyRowsWhenPaging: false,
                                            search: false,
                                        }}
                                    />
                                    : <div className="d-sm-flex d-block border-0 pb-0">
                                        <div className="pr-3 mr-auto mb-sm-0 mb-3 nofoundFullWidth">
                                            <h4 className="fs-20 text-black mb-1 nofoundTitle">List Overview</h4>
                                            <span className="fs-12 nofoundText">No Data Found</span>
                                        </div>
                                    </div>}
                            </div>
                        </div>
                    </div>
                </div>
                {UserData && UserData.is_added_all_share_holders === "No" && (
                <div className="mobileFullWidth">
                    <Link to="#" className="btn btn-primary btn-rounded" onClick={() => setModal6(true)}>
                        Continue
                    </Link>
                </div>
                )}
                </>
            }
        </div>
    )

}
export default Customer_List;